import React from 'react'
import './user-icon.styles.scss'

// Profile picture, or the first letter of the name when there isn't one.
const UserIcon = ({ profile, reverse }) => {
    return (
        <div className={`user-icon-div ${reverse && 'reverse'}`}>
            {profile.icon ?
                <img src={profile.icon} className='user-icon' alt="profile-pic"  referrerPolicy="no-referrer" /> :
                <span className='user-icon user-initial' aria-label='Profile'>{(profile.name ?? '?').trim().charAt(0).toUpperCase()}</span>
            }
        </div>
    )
}

export default UserIcon
